import { NgModule } from '@angular/core';

import { SharedTemplateHeadingComponent } from '~/templates/shared/components/templateHeading/templateHeading';

@NgModule({
    declarations: [
        SharedTemplateHeadingComponent
    ],
    exports: [
        SharedTemplateHeadingComponent
    ]
})

export class SharedTemplateModule {
}